import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import { meetingData } from "../data/meeting";
import DotMenu from "../components/DotMenu";

const columns = [
	{ id: "title", label: "Title", minWidth: 170 },
	{ id: "duration", label: "Duration", minWidth: 100 },
	{
		id: "participants",
		label: "Participants",
		minWidth: 170,
		align: "right",
		format: value => value.toLocaleString()
	},
	{
		id: "date",
		label: "Date",
		minWidth: 170,
		align: "right",
		format: value => value.toLocaleString()
	},
	{
		id: "action",
		label: "Action",
		minWidth: 170,
		align: "right",
		format: value => value.toFixed(2)
	}
];

const rows = meetingData;

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	tableWrapper: {
		maxHeight: 400,
		overflow: "auto"
	}
});

export default function StickyHeadTable() {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = event => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Paper className={classes.root}>
			<div className={classes.tableWrapper}>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							{columns.map(column => (
								<TableCell
									key={column.id}
									align={column.align}
									style={{ minWidth: column.minWidth }}
								>
									{column.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows
							.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
							.map(row => {
								return (
									<TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
										{columns.map((column, index) => {
											const value = row[column.id];
											return (
												<TableCell key={column.id} align={column.align}>
													{index < 4 ? value : <DotMenu />}
												</TableCell>
											);
										})}
									</TableRow>
								);
							})}
					</TableBody>
				</Table>
			</div>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25, 100]}
				component="div"
				count={rows.length}
				rowsPerPage={rowsPerPage}
				page={page}
				backIconButtonProps={{
					"aria-label": "previous page"
				}}
				nextIconButtonProps={{
					"aria-label": "next page"
				}}
				onChangePage={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
			/>
		</Paper>
	);
}
